@import 'tailwindcss';

@utility container {  
   padding-inline: 1rem;
}

@theme {
    --breakpoint-md: 1024px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

a {
  text-decoration: underline;
}
.loading {
  height: 35px;
  fill: black;
  display: none;
}
.connected .loading {
  display: inline;
}
.dark .loading {
  fill: white;
}
.blue,.ansi-blue-fg {
  color: rgb(97, 175, 239)
}
.red,.ansi-red-fg {
  color: rgb(255 123 133);
}
.green,.ansi-green-fg {
  color: rgb(170 255 109);
}
.purple,.ansi-magenta-fg {
  color: rgb(224 124 253);
}
.yellow,.ansi-yellow-fg {
  color: rgb(253 198 94);
}
.ansi-cyan-fg {
  color: rgb(255, 255, 255)
}

.ansi-bright-black-fg {
  color: rgb(169, 169, 169)
}
